/**
 * Sanitizacion de texto para observaciones que terminan en PDF (fuentes Times /
 * Latin-1 en el backend). Emojis, letras estilizadas Unicode y simbolos
 * decorativos no tienen glifo en Times y producen basura en el PDF.
 *
 * Se aplica en el front para que el usuario vea al escribir el mismo texto que
 * saldra en el PDF. El backend aplica la misma logica como red de seguridad.
 */

/** Version completa: NFKD -> NFC -> filtra fuera de Latin-1 -> colapsa espacios -> trim. */
export function sanitizarTextoPdf(texto: string): string {
  if (!texto) return texto;
  return texto
    .normalize('NFKD')
    .normalize('NFC')
    .replace(/[^\x00-\xFF]/g, '')
    .replace(/[ \t]{2,}/g, ' ')
    .trim();
}

/** Version en vivo para onChange: filtra caracteres no soportados SIN trim ni
 * colapso de espacios, para no interferir con la escritura. */
export function sanitizarTextoLive(texto: string): string {
  if (!texto) return texto;
  return texto
    .normalize('NFKD')
    .normalize('NFC')
    .replace(/[^\x00-\xFF]/g, '');
}
